import React from 'react'
import FolderSvg from 'images/modules/Manage/i-folder.svg?raw'

export { default as FolderUrl } from 'images/modules/Manage/i-folder.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: FolderSvg}} />
)
